<div id="livebets_header"
     class="headerTop {{isScoreBox ? 'scoreBox' : ''}}">
  <div class="leftArea headerContainer"
       *ngIf="!isScoreBox">
    <DropdownMenu
      [_DATA]="SPORTS_TYPE"
      [componentWidth]="250"
      [selectDataKey]="'EnumSportType'"
      [isTranslated]=true
      [isBig]=true
      (selectedItem)="sportChangeHandler($event.key)">
    </DropdownMenu>

    <DropdownMenu
      [_DATA]="allLeagues"
      [componentWidth]="270"
      [selectDataKey]="'EnumSportType'"
      [tournamentSportEventCount]="'tournamentSportEventCount'"
      [displayNameKey]="'name'"
      [sportEventCount]="'sportEventCount'"
      [altNameKey]="'alt'"
      [rowNumber]=3
      [isBig]=true
      (selectedItem)="tournamentSelectHandler($event.key,$event.item)">
    </DropdownMenu>


    <div class="centerArea">
      <button class="tiny ui button livebetdatedown_button terminalButton" style="width: 50px !important;"  (click)="OpenStandingsModal()" *ngIf="this.leagueIsActive && this.activeDomain == 'wett'">
        <i class="list alternate outline large icon" style="width: 100%;"></i>
      </button>
    </div>


  </div>


  <div class="leftArea headerContainer"
       *ngIf="isScoreBox">
    <div class="matchTime">
      {{"Time" | t}}
    </div>
    <div class="teamsContainer">
      <div class="lowerArea">
        <div class="homeTeam">
          {{"Home" | t}}
        </div>
        <div class="awayTeam">
          {{"Away" | t}}
        </div>
      </div>
    </div>
    <div class="statusArea">
      {{"Score"  | t}}
    </div>
  </div>

  <div class="rightArea oddTypeView {{isScoreBox ? 'scoreBox': ''}}"
       *ngIf="oddDropDown">
    <oddTypeSelector class="itemW three"
                     [rowNumber]=0
                     [oddNumber]=3
                     [_data]="oddDropDown.first"
                     [onlyHeaderFor]=onlyHeaderFor></oddTypeSelector>
    <oddTypeSelector class="itemW three"
                     [rowNumber]=1
                     [isPaddingLeft]=true
                     [oddNumber]=2
                     [_data]="oddDropDown.second"
                     [onlyHeaderFor]=onlyHeaderFor></oddTypeSelector>
    <oddTypeSelector class="itemW four"
                     [rowNumber]=2
                     [isPaddingLeft]=true
                     [oddNumber]=3
                     [_data]="oddDropDown.third"
                     [onlyHeaderFor]=onlyHeaderFor></oddTypeSelector>
  </div>


</div>
